import { Box, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { DraftNodeList } from 'src/components/NodeSaleList/DraftNodeList';
import { ProductionNodeList } from 'src/components/NodeSaleList/ProductionNodeList';
import { StageFilter } from 'src/components/StageFilter';
import { ProjectStageEnum } from 'src/global/enums/project.enum';
import { colors } from 'src/global/styles/colors';
import { projectApi } from 'src/store/services/project.service';

const NodeSaleList = () => {
  const [selectedStage, setSelectedStage] = useState<ProjectStageEnum>(ProjectStageEnum.DRAFT);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(projectApi.util.invalidateTags([{ type: 'Project', id: selectedStage }]));
  }, [selectedStage]);

  return (
    <Box width={'100%'} height={'100%'} display={'flex'} minHeight={'100dvh'} flexDirection={'column'} paddingTop={5}>
      <Typography variant={'h4'} fontSize={'32px'} fontWeight={700} color='white' textAlign={'center'}>
        NFT SALE PROGRAM
      </Typography>
      <Typography
        variant={'h6'}
        fontSize={'16px'}
        fontWeight={400}
        lineHeight={'20px'}
        color={colors.neutral90}
        marginTop={2}
        textAlign={'center'}>
        Fund, accelerate and scale your project with our sale program.
      </Typography>
      <Stack width={'100%'} marginY={4} justifyContent={'center'} alignItems={'center'}>
        <StageFilter
          stages={[ProjectStageEnum.DRAFT, ProjectStageEnum.PRODUCTION]}
          selectedStage={selectedStage}
          setSelectedStage={setSelectedStage}
        />
      </Stack>
      <Box width={'100%'} maxWidth={'1120px'} display={'flex'} flexDirection={'column'} marginX={'auto'}>
        {selectedStage === ProjectStageEnum.DRAFT ? <DraftNodeList /> : <ProductionNodeList />}
      </Box>
    </Box>
  );
};

export default NodeSaleList;
